import { Container } from '../ListInformation.styles';

const ListInformationError = () => {
  return <Container>Error on load general informations</Container>;
};

export { ListInformationError };
